import { z } from 'zod';
import { ipv4OptionalPortRegex, ipv6OptionalPortRegex } from '../general/helpers/ip-address.ts';
import { invalidPort } from '../general/helpers/port.ts';

export const INVALID_HOST_OR_PORT = 'Invalid host or port';
export const INVALID_PORT_ERR = 'Invalid port';

const portRegex = /^:([0-9]{1,5})$/;

/**
 * Check regex errors to see if we can be a bit more exact, and throw a port error message instead
 */
const errorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code === 'invalid_string' && issue.validation === 'regex') {
    if (
      invalidPort(ctx.data, ipv4OptionalPortRegex) ||
      invalidPort(ctx.data, ipv6OptionalPortRegex) ||
      invalidPort(ctx.data, /^:([0-9]*)$/) // different from portRegex so we can get ports with too many digits
    ) {
      return { message: INVALID_PORT_ERR };
    }
    return { message: INVALID_HOST_OR_PORT };
  }
  return { message: ctx.defaultError };
};

const ipv6Schema = z
  .string({ errorMap })
  .regex(ipv6OptionalPortRegex)
  .refine((value) => !invalidPort(value, ipv6OptionalPortRegex), INVALID_PORT_ERR);

const ipv4Schema = z
  .string({ errorMap })
  .regex(ipv4OptionalPortRegex)
  .refine((value) => !invalidPort(value, ipv4OptionalPortRegex), INVALID_PORT_ERR);

const portSchema = z
  .string({ errorMap })
  .regex(portRegex)
  .refine((value) => !invalidPort(value, portRegex), INVALID_PORT_ERR);

/**
 * {@link statsListenSchema} parses a string to a valid ipv4/ipv6 address
 * with an optional port, or just a port, or an empty string.
 */
export const statsListenSchema = z
  .union([portSchema, ipv6Schema, ipv4Schema], { invalid_type_error: INVALID_HOST_OR_PORT })
  .or(z.literal(''));
